var map = {
	"./": [
		373,
		60847,
		24705
	],
	"./AcerIcon": [
		74751,
		11896
	],
	"./AcerIcon.js": [
		74751,
		11896
	],
	"./AchievementIcon": [
		50607,
		37514
	],
	"./AchievementIcon.js": [
		50607,
		37514
	],
	"./ActionStreamOnIcon": [
		39743,
		30908
	],
	"./ActionStreamOnIcon.js": [
		39743,
		30908
	],
	"./AddCardIcon": [
		88161,
		8110
	],
	"./AddCardIcon.js": [
		88161,
		8110
	],
	"./AddCircleIcon": [
		38427,
		90064
	],
	"./AddCircleIcon.js": [
		38427,
		90064
	],
	"./AddDeviceIcon": [
		80709,
		88609
	],
	"./AddDeviceIcon.js": [
		80709,
		88609
	],
	"./AddFolderIcon": [
		76079,
		30419
	],
	"./AddFolderIcon.js": [
		76079,
		30419
	],
	"./AddIcon": [
		75887,
		7621
	],
	"./AddIcon.js": [
		75887,
		7621
	],
	"./AlcatelIcon": [
		55358,
		33239
	],
	"./AlcatelIcon.js": [
		55358,
		33239
	],
	"./AmericanexpressIcon": [
		78502,
		15193
	],
	"./AmericanexpressIcon.js": [
		78502,
		15193
	],
	"./AnalyticsIcon": [
		25816,
		63824
	],
	"./AnalyticsIcon.js": [
		25816,
		63824
	],
	"./AngleDownIcon": [
		6695,
		41026
	],
	"./AngleDownIcon.js": [
		6695,
		41026
	],
	"./AngleLeftIcon": [
		70706
	],
	"./AngleLeftIcon.js": [
		70706
	],
	"./AngleRightIcon": [
		41839
	],
	"./AngleRightIcon.js": [
		41839
	],
	"./AngleUpIcon": [
		27466,
		85656
	],
	"./AngleUpIcon.js": [
		27466,
		85656
	],
	"./AppStoreIcon": [
		75144
	],
	"./AppStoreIcon.js": [
		75144
	],
	"./AppleIcon": [
		7100,
		62917
	],
	"./AppleIcon.js": [
		7100,
		62917
	],
	"./AppleStoreIcon": [
		44213,
		37299
	],
	"./AppleStoreIcon.js": [
		44213,
		37299
	],
	"./ApplicationsIcon": [
		92111,
		43905
	],
	"./ApplicationsIcon.js": [
		92111,
		43905
	],
	"./ArIcon": [
		86695,
		18287
	],
	"./ArIcon.js": [
		86695,
		18287
	],
	"./ArrowLeftIcon": [
		52444,
		98982
	],
	"./ArrowLeftIcon.js": [
		52444,
		98982
	],
	"./ArrowRightIcon": [
		36737,
		57172
	],
	"./ArrowRightIcon.js": [
		36737,
		57172
	],
	"./AsusIcon": [
		99404,
		79970
	],
	"./AsusIcon.js": [
		99404,
		79970
	],
	"./AttachmentIcon": [
		19021,
		54352
	],
	"./AttachmentIcon.js": [
		19021,
		54352
	],
	"./AudioFileIcon": [
		53800,
		72398
	],
	"./AudioFileIcon.js": [
		53800,
		72398
	],
	"./AudioRecordingIcon": [
		87381,
		8685
	],
	"./AudioRecordingIcon.js": [
		87381,
		8685
	],
	"./AuntIcon": [
		65540,
		50495
	],
	"./AuntIcon.js": [
		65540,
		50495
	],
	"./AutoLoginIcon": [
		83912,
		5865
	],
	"./AutoLoginIcon.js": [
		83912,
		5865
	],
	"./BackspaceIcon": [
		63127,
		31483
	],
	"./BackspaceIcon.js": [
		63127,
		31483
	],
	"./BackwardIcon": [
		88925,
		46709
	],
	"./BackwardIcon.js": [
		88925,
		46709
	],
	"./BankIdButtonIcon": [
		64379,
		90428
	],
	"./BankIdButtonIcon.js": [
		64379,
		90428
	],
	"./BarCodeIcon": [
		56283,
		16046
	],
	"./BarCodeIcon.js": [
		56283,
		16046
	],
	"./BillingIcon": [
		93403,
		19832
	],
	"./BillingIcon.js": [
		93403,
		19832
	],
	"./BillingNewIcon": [
		8767,
		97034
	],
	"./BillingNewIcon.js": [
		8767,
		97034
	],
	"./BillingSolidIcon": [
		38578,
		820
	],
	"./BillingSolidIcon.js": [
		38578,
		820
	],
	"./BinIcon": [
		97965,
		48387
	],
	"./BinIcon.js": [
		97965,
		48387
	],
	"./BiometricIcon": [
		67174,
		54993
	],
	"./BiometricIcon.js": [
		67174,
		54993
	],
	"./BoldPlusIconIcon": [
		67550,
		51207
	],
	"./BoldPlusIconIcon.js": [
		67550,
		51207
	],
	"./BrandLogoAppleIcon": [
		53998,
		25589
	],
	"./BrandLogoAppleIcon.js": [
		53998,
		25589
	],
	"./BusinessCardIcon": [
		48476,
		10363
	],
	"./BusinessCardIcon.js": [
		48476,
		10363
	],
	"./CalendarIcon": [
		84906
	],
	"./CalendarIcon.js": [
		84906
	],
	"./CalendarSolidIcon": [
		50417
	],
	"./CalendarSolidIcon.js": [
		50417
	],
	"./CallIcon": [
		85004,
		2982
	],
	"./CallIcon.js": [
		85004,
		2982
	],
	"./CallIncomingIcon": [
		45820,
		9588
	],
	"./CallIncomingIcon.js": [
		45820,
		9588
	],
	"./CallOutgoingIcon": [
		510,
		5802
	],
	"./CallOutgoingIcon.js": [
		510,
		5802
	],
	"./CameraIcon": [
		65607,
		41929
	],
	"./CameraIcon.js": [
		65607,
		41929
	],
	"./CancelIcon": [
		79182,
		19131
	],
	"./CancelIcon.js": [
		79182,
		19131
	],
	"./CanonIcon": [
		7,
		44749
	],
	"./CanonIcon.js": [
		7,
		44749
	],
	"./CaretIcon": [
		76459,
		38143
	],
	"./CaretIcon.js": [
		76459,
		38143
	],
	"./CaretNewIcon": [
		53903,
		63761
	],
	"./CaretNewIcon.js": [
		53903,
		63761
	],
	"./CatIcon": [
		84956,
		54625
	],
	"./CatIcon.js": [
		84956,
		54625
	],
	"./ChangeCameraIcon": [
		53411,
		31667
	],
	"./ChangeCameraIcon.js": [
		53411,
		31667
	],
	"./ChangelogIcon": [
		5890,
		73637
	],
	"./ChangelogIcon.js": [
		5890,
		73637
	],
	"./ChatIcon": [
		91650,
		50839
	],
	"./ChatIcon.js": [
		91650,
		50839
	],
	"./ChildSimCardIcon": [
		55647,
		16441
	],
	"./ChildSimCardIcon.js": [
		55647,
		16441
	],
	"./CircleAddIcon": [
		3495,
		85018
	],
	"./CircleAddIcon.js": [
		3495,
		85018
	],
	"./CircleAddonIcon": [
		65522,
		91464
	],
	"./CircleAddonIcon.js": [
		65522,
		91464
	],
	"./CircleCheckIcon": [
		40504,
		87678
	],
	"./CircleCheckIcon.js": [
		40504,
		87678
	],
	"./CircleCheckListIcon": [
		47516,
		10476
	],
	"./CircleCheckListIcon.js": [
		47516,
		10476
	],
	"./CircleCheckThinIcon": [
		36863,
		95250
	],
	"./CircleCheckThinIcon.js": [
		36863,
		95250
	],
	"./CircleCloseIcon": [
		62844
	],
	"./CircleCloseIcon.js": [
		62844
	],
	"./CircleErrorIcon": [
		11858,
		52517
	],
	"./CircleErrorIcon.js": [
		11858,
		52517
	],
	"./CircleHelpIcon": [
		69323,
		75315
	],
	"./CircleHelpIcon.js": [
		69323,
		75315
	],
	"./CircleInformationIcon": [
		99906,
		33505
	],
	"./CircleInformationIcon.js": [
		99906,
		33505
	],
	"./CircleMinusIcon": [
		2140,
		56303
	],
	"./CircleMinusIcon.js": [
		2140,
		56303
	],
	"./CircleRefreshIcon": [
		51399,
		65072
	],
	"./CircleRefreshIcon.js": [
		51399,
		65072
	],
	"./CircleStarIcon": [
		69552,
		90690
	],
	"./CircleStarIcon.js": [
		69552,
		90690
	],
	"./CircleTopUpIcon": [
		262,
		67892
	],
	"./CircleTopUpIcon.js": [
		262,
		67892
	],
	"./ClipboardIcon": [
		29650,
		9702
	],
	"./ClipboardIcon.js": [
		29650,
		9702
	],
	"./ClipboardNewIcon": [
		45560,
		86904
	],
	"./ClipboardNewIcon.js": [
		45560,
		86904
	],
	"./ClockIcon": [
		41746,
		46701
	],
	"./ClockIcon.js": [
		41746,
		46701
	],
	"./ClockNewIcon": [
		58776,
		40095
	],
	"./ClockNewIcon.js": [
		58776,
		40095
	],
	"./CloseIcon": [
		96292
	],
	"./CloseIcon.js": [
		96292
	],
	"./CloudsIcon": [
		17538,
		21083
	],
	"./CloudsIcon.js": [
		17538,
		21083
	],
	"./CollapseIcon": [
		77491,
		36309
	],
	"./CollapseIcon.js": [
		77491,
		36309
	],
	"./CombinedIcon": [
		72751,
		4934
	],
	"./CombinedIcon.js": [
		72751,
		4934
	],
	"./CommunicationNetworkSignalIcon": [
		80258,
		11540
	],
	"./CommunicationNetworkSignalIcon.js": [
		80258,
		11540
	],
	"./CommunitiesIcon": [
		37709,
		85922
	],
	"./CommunitiesIcon.js": [
		37709,
		85922
	],
	"./ComputerIcon": [
		98077,
		8720
	],
	"./ComputerIcon.js": [
		98077,
		8720
	],
	"./ConfirmBoldIcon": [
		64811,
		26766
	],
	"./ConfirmBoldIcon.js": [
		64811,
		26766
	],
	"./ConfirmIcon": [
		44312,
		65987
	],
	"./ConfirmIcon.js": [
		44312,
		65987
	],
	"./ContactsIcon": [
		55793,
		72593
	],
	"./ContactsIcon.js": [
		55793,
		72593
	],
	"./ContentIcon": [
		79121,
		68807
	],
	"./ContentIcon.js": [
		79121,
		68807
	],
	"./ContentSolidIcon": [
		17948,
		91605
	],
	"./ContentSolidIcon.js": [
		17948,
		91605
	],
	"./ContinueIcon": [
		30081,
		76379
	],
	"./ContinueIcon.js": [
		30081,
		76379
	],
	"./ContractsIcon": [
		16175,
		40092
	],
	"./ContractsIcon.js": [
		16175,
		40092
	],
	"./ContractsNewIcon": [
		77427,
		33646
	],
	"./ContractsNewIcon.js": [
		77427,
		33646
	],
	"./ContractsSolidIcon": [
		14726,
		37432
	],
	"./ContractsSolidIcon.js": [
		14726,
		37432
	],
	"./CoolIcon": [
		5045
	],
	"./CoolIcon.js": [
		5045
	],
	"./CopyDashedIcon": [
		26688,
		18420
	],
	"./CopyDashedIcon.js": [
		26688,
		18420
	],
	"./CousinIcon": [
		8941,
		59529
	],
	"./CousinIcon.js": [
		8941,
		59529
	],
	"./CreditCardIcon": [
		51455,
		85147
	],
	"./CreditCardIcon.js": [
		51455,
		85147
	],
	"./CurrentLocalizationIcon": [
		43880,
		62349
	],
	"./CurrentLocalizationIcon.js": [
		43880,
		62349
	],
	"./DadIcon": [
		26229,
		4159
	],
	"./DadIcon.js": [
		26229,
		4159
	],
	"./DaughterIcon": [
		48012,
		81361
	],
	"./DaughterIcon.js": [
		48012,
		81361
	],
	"./DefaultFooterLogoIcon": [
		13609,
		49986
	],
	"./DefaultFooterLogoIcon.js": [
		13609,
		49986
	],
	"./DeliveryIcon": [
		88280,
		8016
	],
	"./DeliveryIcon.js": [
		88280,
		8016
	],
	"./DeviceCameraIcon": [
		22889,
		68998
	],
	"./DeviceCameraIcon.js": [
		22889,
		68998
	],
	"./DevicePhoneIcon": [
		59918,
		27188
	],
	"./DevicePhoneIcon.js": [
		59918,
		27188
	],
	"./DevicePhoneWithPlanIcon": [
		16753,
		71818
	],
	"./DevicePhoneWithPlanIcon.js": [
		16753,
		71818
	],
	"./DeviceRouterIcon": [
		41015,
		8770
	],
	"./DeviceRouterIcon.js": [
		41015,
		8770
	],
	"./DeviceTvIcon": [
		77328,
		83152
	],
	"./DeviceTvIcon.js": [
		77328,
		83152
	],
	"./DeviceWatchIcon": [
		16021,
		27782
	],
	"./DeviceWatchIcon.js": [
		16021,
		27782
	],
	"./DevicesFixedIcon": [
		56959,
		85972
	],
	"./DevicesFixedIcon.js": [
		56959,
		85972
	],
	"./DevicesFixedSolidIcon": [
		11574,
		30602
	],
	"./DevicesFixedSolidIcon.js": [
		11574,
		30602
	],
	"./DevicesServiceIcon": [
		36090,
		18313
	],
	"./DevicesServiceIcon.js": [
		36090,
		18313
	],
	"./DigitalBankingIcon": [
		75354,
		43931
	],
	"./DigitalBankingIcon.js": [
		75354,
		43931
	],
	"./DisabledMicrophoneIcon": [
		83044,
		21133
	],
	"./DisabledMicrophoneIcon.js": [
		83044,
		21133
	],
	"./DiscountIcon": [
		64307,
		62943
	],
	"./DiscountIcon.js": [
		64307,
		62943
	],
	"./DiscountTagIcon": [
		22681
	],
	"./DiscountTagIcon.js": [
		22681
	],
	"./DjiIcon": [
		94185,
		48632
	],
	"./DjiIcon.js": [
		94185,
		48632
	],
	"./DotSolidIcon": [
		53414,
		25834
	],
	"./DotSolidIcon.js": [
		53414,
		25834
	],
	"./DownloadIcon": [
		82624,
		19228
	],
	"./DownloadIcon.js": [
		82624,
		19228
	],
	"./DtLogoIcon": [
		33571,
		44846
	],
	"./DtLogoIcon.js": [
		33571,
		44846
	],
	"./DtLogoSquareIcon": [
		2316,
		26800
	],
	"./DtLogoSquareIcon.js": [
		2316,
		26800
	],
	"./DtLogoTwoIcon": [
		82767
	],
	"./DtLogoTwoIcon.js": [
		82767
	],
	"./DualSimIcon": [
		9701,
		64781
	],
	"./DualSimIcon.js": [
		9701,
		64781
	],
	"./ESimIcon": [
		1050,
		39163
	],
	"./ESimIcon.js": [
		1050,
		39163
	],
	"./EcoRatingIcon": [
		78028,
		61961
	],
	"./EcoRatingIcon.js": [
		78028,
		61961
	],
	"./EditIcon": [
		34772,
		80007
	],
	"./EditIcon.js": [
		34772,
		80007
	],
	"./EditWithShadowIcon": [
		25184,
		35374
	],
	"./EditWithShadowIcon.js": [
		25184,
		35374
	],
	"./ElectronicSignIcon": [
		95751,
		58172
	],
	"./ElectronicSignIcon.js": [
		95751,
		58172
	],
	"./EllipsisIcon": [
		39915,
		64778
	],
	"./EllipsisIcon.js": [
		39915,
		64778
	],
	"./EmailIcon": [
		28420,
		39160
	],
	"./EmailIcon.js": [
		28420,
		39160
	],
	"./EmergencyTriangleIcon": [
		19421,
		61958
	],
	"./EmergencyTriangleIcon.js": [
		19421,
		61958
	],
	"./EmergencyTriangleSolidIcon": [
		77736,
		93333
	],
	"./EmergencyTriangleSolidIcon.js": [
		77736,
		93333
	],
	"./EpsonIcon": [
		77627,
		86887
	],
	"./EpsonIcon.js": [
		77627,
		86887
	],
	"./EquipmentIcon": [
		56096,
		90673
	],
	"./EquipmentIcon.js": [
		56096,
		90673
	],
	"./ErrorIcon": [
		38250,
		67715
	],
	"./ErrorIcon.js": [
		38250,
		67715
	],
	"./EuIcon": [
		87374,
		71661
	],
	"./EuIcon.js": [
		87374,
		71661
	],
	"./ExclamationIcon": [
		3153,
		52356
	],
	"./ExclamationIcon.js": [
		3153,
		52356
	],
	"./ExpandIcon": [
		47036,
		45750
	],
	"./ExpandIcon.js": [
		47036,
		45750
	],
	"./ExternalLinkIcon": [
		17403,
		49536
	],
	"./ExternalLinkIcon.js": [
		17403,
		49536
	],
	"./ExternalLinkNewIcon": [
		84799,
		26738
	],
	"./ExternalLinkNewIcon.js": [
		84799,
		26738
	],
	"./EyebrowIcon": [
		86319,
		41964
	],
	"./EyebrowIcon.js": [
		86319,
		41964
	],
	"./FacebookIcon": [
		22460,
		61899
	],
	"./FacebookIcon.js": [
		22460,
		61899
	],
	"./FacebookSolidIcon": [
		28543,
		84697
	],
	"./FacebookSolidIcon.js": [
		28543,
		84697
	],
	"./FairphoneIcon": [
		22250,
		80911
	],
	"./FairphoneIcon.js": [
		22250,
		80911
	],
	"./FamiliesIcon": [
		24052,
		87517
	],
	"./FamiliesIcon.js": [
		24052,
		87517
	],
	"./FamilyIcon": [
		76828,
		99923
	],
	"./FamilyIcon.js": [
		76828,
		99923
	],
	"./FavoriteIcon": [
		30388,
		43802
	],
	"./FavoriteIcon.js": [
		30388,
		43802
	],
	"./FeaturesIcon": [
		37891,
		66600
	],
	"./FeaturesIcon.js": [
		37891,
		66600
	],
	"./FeedbackIcon": [
		87855,
		62814
	],
	"./FeedbackIcon.js": [
		87855,
		62814
	],
	"./FileIcon": [
		81034,
		85612
	],
	"./FileIcon.js": [
		81034,
		85612
	],
	"./FileLinkIcon": [
		51098,
		70386
	],
	"./FileLinkIcon.js": [
		51098,
		70386
	],
	"./FilterIcon": [
		46802,
		13409
	],
	"./FilterIcon.js": [
		46802,
		13409
	],
	"./FilterNewIcon": [
		16120,
		6803
	],
	"./FilterNewIcon.js": [
		16120,
		6803
	],
	"./FindIcon": [
		19331,
		32421
	],
	"./FindIcon.js": [
		19331,
		32421
	],
	"./FixedLineIcon": [
		89284
	],
	"./FixedLineIcon.js": [
		89284
	],
	"./FixedLineServicesIcon": [
		17536,
		91577
	],
	"./FixedLineServicesIcon.js": [
		17536,
		91577
	],
	"./FixedTariffIcon": [
		47632,
		30627
	],
	"./FixedTariffIcon.js": [
		47632,
		30627
	],
	"./FlexibleTariffsIcon": [
		85882,
		37233
	],
	"./FlexibleTariffsIcon.js": [
		85882,
		37233
	],
	"./FolderIcon": [
		80328,
		33447
	],
	"./FolderIcon.js": [
		80328,
		33447
	],
	"./FooterLogoCzIcon": [
		44073,
		7829
	],
	"./FooterLogoCzIcon.js": [
		44073,
		7829
	],
	"./FooterLogoDeIcon": [
		20539,
		92603
	],
	"./FooterLogoDeIcon.js": [
		20539,
		92603
	],
	"./FooterLogoHrIcon": [
		44050,
		72668
	],
	"./FooterLogoHrIcon.js": [
		44050,
		72668
	],
	"./FooterLogoHuIcon": [
		16559,
		98286
	],
	"./FooterLogoHuIcon.js": [
		16559,
		98286
	],
	"./FooterLogoMeIcon": [
		80766,
		2072
	],
	"./FooterLogoMeIcon.js": [
		80766,
		2072
	],
	"./FooterLogoMkKyrIcon": [
		85450,
		79274
	],
	"./FooterLogoMkKyrIcon.js": [
		85450,
		79274
	],
	"./FooterLogoMkLatinIcon": [
		1010,
		83060
	],
	"./FooterLogoMkLatinIcon.js": [
		1010,
		83060
	],
	"./FooterLogoPlIcon": [
		88908,
		74573
	],
	"./FooterLogoPlIcon.js": [
		88908,
		74573
	],
	"./FooterLogoRoIcon": [
		43875,
		16383
	],
	"./FooterLogoRoIcon.js": [
		43875,
		16383
	],
	"./FooterLogoSkIcon": [
		38734,
		71753
	],
	"./FooterLogoSkIcon.js": [
		38734,
		71753
	],
	"./ForkIcon": [
		24772,
		97371
	],
	"./ForkIcon.js": [
		24772,
		97371
	],
	"./FullScreenIcon": [
		21445,
		12597
	],
	"./FullScreenIcon.js": [
		21445,
		12597
	],
	"./GamingIcon": [
		23345,
		81222
	],
	"./GamingIcon.js": [
		23345,
		81222
	],
	"./GarminIcon": [
		51050,
		39412
	],
	"./GarminIcon.js": [
		51050,
		39412
	],
	"./GiftIcon": [
		57542
	],
	"./GiftIcon.js": [
		57542
	],
	"./GladIcon": [
		53610,
		36592
	],
	"./GladIcon.js": [
		53610,
		36592
	],
	"./GoogleFullIcon": [
		7102,
		54638
	],
	"./GoogleFullIcon.js": [
		7102,
		54638
	],
	"./GoogleIcon": [
		5535,
		22359
	],
	"./GoogleIcon.js": [
		5535,
		22359
	],
	"./GoogleNewIcon": [
		27683,
		45157
	],
	"./GoogleNewIcon.js": [
		27683,
		45157
	],
	"./GooglePlayIcon": [
		21293
	],
	"./GooglePlayIcon.js": [
		21293
	],
	"./GooglePlayNewIcon": [
		2029,
		26145
	],
	"./GooglePlayNewIcon.js": [
		2029,
		26145
	],
	"./GoproIcon": [
		93537,
		527
	],
	"./GoproIcon.js": [
		93537,
		527
	],
	"./GrandmotherIcon": [
		40601,
		29712
	],
	"./GrandmotherIcon.js": [
		40601,
		29712
	],
	"./GrayscaleCardIcon": [
		10877,
		6914
	],
	"./GrayscaleCardIcon.js": [
		10877,
		6914
	],
	"./HammerIcon": [
		89234,
		48884
	],
	"./HammerIcon.js": [
		89234,
		48884
	],
	"./HandshakeIcon": [
		23017,
		25926
	],
	"./HandshakeIcon.js": [
		23017,
		25926
	],
	"./HeartIcon": [
		83916
	],
	"./HeartIcon.js": [
		83916
	],
	"./HelpIcon": [
		32931
	],
	"./HelpIcon.js": [
		32931
	],
	"./HeyahEcomPinezkaIcon": [
		35245,
		12659
	],
	"./HeyahEcomPinezkaIcon.js": [
		35245,
		12659
	],
	"./HeyahEcomPinezkaNormalIcon": [
		4710,
		89861
	],
	"./HeyahEcomPinezkaNormalIcon.js": [
		4710,
		89861
	],
	"./HeyahShopLocalizerIcon": [
		5974,
		15479
	],
	"./HeyahShopLocalizerIcon.js": [
		5974,
		15479
	],
	"./HidePasswordIcon": [
		8589,
		97433
	],
	"./HidePasswordIcon.js": [
		8589,
		97433
	],
	"./HighFibreSecurityIcon": [
		39398
	],
	"./HighFibreSecurityIcon.js": [
		39398
	],
	"./HighOpticFibreIcon": [
		74715
	],
	"./HighOpticFibreIcon.js": [
		74715
	],
	"./HighSpeedWifiIcon": [
		32478
	],
	"./HighSpeedWifiIcon.js": [
		32478
	],
	"./HistoryIcon": [
		8800,
		54700
	],
	"./HistoryIcon.js": [
		8800,
		54700
	],
	"./HistoryNewIcon": [
		73650,
		39474
	],
	"./HistoryNewIcon.js": [
		73650,
		39474
	],
	"./HomeIcon": [
		52411,
		79403
	],
	"./HomeIcon.js": [
		52411,
		79403
	],
	"./HomeInternetIcon": [
		71690,
		53785
	],
	"./HomeInternetIcon.js": [
		71690,
		53785
	],
	"./HonorIcon": [
		61268,
		49999
	],
	"./HonorIcon.js": [
		61268,
		49999
	],
	"./HuaweiAppGallaryIcon": [
		66642,
		56605
	],
	"./HuaweiAppGallaryIcon.js": [
		66642,
		56605
	],
	"./HuaweiIcon": [
		98433,
		69011
	],
	"./HuaweiIcon.js": [
		98433,
		69011
	],
	"./Icon": [
		49264,
		9796
	],
	"./Icon.js": [
		49264,
		9796
	],
	"./IdCardIcon": [
		59871,
		3190
	],
	"./IdCardIcon.js": [
		59871,
		3190
	],
	"./ImageOptionIcon": [
		45488,
		6976
	],
	"./ImageOptionIcon.js": [
		45488,
		6976
	],
	"./ImprintDataprivacyIcon": [
		9203,
		32594
	],
	"./ImprintDataprivacyIcon.js": [
		9203,
		32594
	],
	"./InStockIcon": [
		20395,
		47820
	],
	"./InStockIcon.js": [
		20395,
		47820
	],
	"./InfinityIcon": [
		88304,
		68580
	],
	"./InfinityIcon.js": [
		88304,
		68580
	],
	"./InformationIcon": [
		70970,
		61974
	],
	"./InformationIcon.js": [
		70970,
		61974
	],
	"./InstagramIcon": [
		86568
	],
	"./InstagramIcon.js": [
		86568
	],
	"./InstagramSolidIcon": [
		58939,
		91378
	],
	"./InstagramSolidIcon.js": [
		58939,
		91378
	],
	"./InstallationServiceIcon": [
		92455,
		6604
	],
	"./InstallationServiceIcon.js": [
		92455,
		6604
	],
	"./InternalLinkIcon": [
		17609,
		54539
	],
	"./InternalLinkIcon.js": [
		17609,
		54539
	],
	"./InternationalIcon": [
		64164,
		12569
	],
	"./InternationalIcon.js": [
		64164,
		12569
	],
	"./InternationalSmsIcon": [
		68549,
		8783
	],
	"./InternationalSmsIcon.js": [
		68549,
		8783
	],
	"./InternetAddonsIcon": [
		30938,
		31741
	],
	"./InternetAddonsIcon.js": [
		30938,
		31741
	],
	"./InternetAtHomeIcon": [
		92831,
		27795
	],
	"./InternetAtHomeIcon.js": [
		92831,
		27795
	],
	"./InternetIcon": [
		82073
	],
	"./InternetIcon.js": [
		82073
	],
	"./InvisibleIcon": [
		54863,
		90748
	],
	"./InvisibleIcon.js": [
		54863,
		90748
	],
	"./IotIcon": [
		92792,
		97354
	],
	"./IotIcon.js": [
		92792,
		97354
	],
	"./IrobotIcon": [
		69393,
		20152
	],
	"./IrobotIcon.js": [
		69393,
		20152
	],
	"./KeyIcon": [
		2591,
		94534
	],
	"./KeyIcon.js": [
		2591,
		94534
	],
	"./LandlineIcon": [
		95367,
		25909
	],
	"./LandlineIcon.js": [
		95367,
		25909
	],
	"./LaunchIcon": [
		95747,
		51527
	],
	"./LaunchIcon.js": [
		95747,
		51527
	],
	"./LenovoIcon": [
		63103,
		55313
	],
	"./LenovoIcon.js": [
		63103,
		55313
	],
	"./LgIcon": [
		1845,
		48707
	],
	"./LgIcon.js": [
		1845,
		48707
	],
	"./LinkedinIcon": [
		79705
	],
	"./LinkedinIcon.js": [
		79705
	],
	"./ListIcon": [
		7924,
		76504
	],
	"./ListIcon.js": [
		7924,
		76504
	],
	"./LoadingIcon": [
		7868,
		2122
	],
	"./LoadingIcon.js": [
		7868,
		2122
	],
	"./LocationIcon": [
		327,
		95516
	],
	"./LocationIcon.js": [
		327,
		95516
	],
	"./LocationIconSolidIcon": [
		95081,
		72718
	],
	"./LocationIconSolidIcon.js": [
		95081,
		72718
	],
	"./LockIcon": [
		47659,
		54672
	],
	"./LockIcon.js": [
		47659,
		54672
	],
	"./LockNewIcon": [
		19023,
		34463
	],
	"./LockNewIcon.js": [
		19023,
		34463
	],
	"./LockerIcon": [
		26628,
		92653
	],
	"./LockerIcon.js": [
		26628,
		92653
	],
	"./LogoWith2DotIcon": [
		70466,
		15451
	],
	"./LogoWith2DotIcon.js": [
		70466,
		15451
	],
	"./LogoutAIcon": [
		27397,
		89833
	],
	"./LogoutAIcon.js": [
		27397,
		89833
	],
	"./LogoutIcon": [
		15378,
		7879
	],
	"./LogoutIcon.js": [
		15378,
		7879
	],
	"./LoyaltyIcon": [
		99302,
		24994
	],
	"./LoyaltyIcon.js": [
		99302,
		24994
	],
	"./MaestroIcon": [
		68253,
		47792
	],
	"./MaestroIcon.js": [
		68253,
		47792
	],
	"./MaestroNewIcon": [
		59357,
		44006
	],
	"./MaestroNewIcon.js": [
		59357,
		44006
	],
	"./MagentaCloudIcon": [
		3996,
		50612
	],
	"./MagentaCloudIcon.js": [
		3996,
		50612
	],
	"./MagentaTvIcon": [
		44149,
		46826
	],
	"./MagentaTvIcon.js": [
		44149,
		46826
	],
	"./MagentaoneIcon": [
		6421,
		82953
	],
	"./MagentaoneIcon.js": [
		6421,
		82953
	],
	"./MaintananceIcon": [
		78375,
		60155
	],
	"./MaintananceIcon.js": [
		78375,
		60155
	],
	"./MaintenanceBannerIcon": [
		39501,
		2125
	],
	"./MaintenanceBannerIcon.js": [
		39501,
		2125
	],
	"./MaintenanceHeaderLogoIcon": [
		56645,
		79167
	],
	"./MaintenanceHeaderLogoIcon.js": [
		56645,
		79167
	],
	"./MastercardIcon": [
		16388,
		4785
	],
	"./MastercardIcon.js": [
		16388,
		4785
	],
	"./MaxcomIcon": [
		35631,
		31452
	],
	"./MaxcomIcon.js": [
		35631,
		31452
	],
	"./MeasureInternetSpeedIcon": [
		48744,
		57070
	],
	"./MeasureInternetSpeedIcon.js": [
		48744,
		57070
	],
	"./MediaFolderIcon": [
		21528,
		60856
	],
	"./MediaFolderIcon.js": [
		21528,
		60856
	],
	"./MediaReceiverIcon": [
		15965,
		38058
	],
	"./MediaReceiverIcon.js": [
		15965,
		38058
	],
	"./MenuIcon": [
		28131,
		41844
	],
	"./MenuIcon.js": [
		28131,
		41844
	],
	"./MenuNewIcon": [
		37415,
		89411
	],
	"./MenuNewIcon.js": [
		37415,
		89411
	],
	"./MenuOldIcon": [
		28684,
		96017
	],
	"./MenuOldIcon.js": [
		28684,
		96017
	],
	"./MenuWithSearchIcon": [
		43299,
		92231
	],
	"./MenuWithSearchIcon.js": [
		43299,
		92231
	],
	"./MessageIcon": [
		16047,
		66613
	],
	"./MessageIcon.js": [
		16047,
		66613
	],
	"./MicrobitIcon": [
		70503,
		51387
	],
	"./MicrobitIcon.js": [
		70503,
		51387
	],
	"./MicrophoneIcon": [
		71068,
		39653
	],
	"./MicrophoneIcon.js": [
		71068,
		39653
	],
	"./MicrosoftIcon": [
		85584,
		16855
	],
	"./MicrosoftIcon.js": [
		85584,
		16855
	],
	"./MinusIcon": [
		94036,
		20641
	],
	"./MinusIcon.js": [
		94036,
		20641
	],
	"./MnpBonusIcon": [
		85972,
		14035
	],
	"./MnpBonusIcon.js": [
		85972,
		14035
	],
	"./MobileDevicesCombinationIcon": [
		55156,
		1629
	],
	"./MobileDevicesCombinationIcon.js": [
		55156,
		1629
	],
	"./MobileEquipmentIcon": [
		62138,
		70046
	],
	"./MobileEquipmentIcon.js": [
		62138,
		70046
	],
	"./MobilePhoneInsuranceIcon": [
		90578,
		92844
	],
	"./MobilePhoneInsuranceIcon.js": [
		90578,
		92844
	],
	"./MobileServicesIcon": [
		5506,
		51034
	],
	"./MobileServicesIcon.js": [
		5506,
		51034
	],
	"./MotorolaIcon": [
		96825,
		73832
	],
	"./MotorolaIcon.js": [
		96825,
		73832
	],
	"./MoveIcon": [
		77597,
		48214
	],
	"./MoveIcon.js": [
		77597,
		48214
	],
	"./MultipleDeviceIcon": [
		85246
	],
	"./MultipleDeviceIcon.js": [
		85246
	],
	"./MyLocationIcon": [
		29201,
		82601
	],
	"./MyLocationIcon.js": [
		29201,
		82601
	],
	"./MyphoneIcon": [
		85526,
		27231
	],
	"./MyphoneIcon.js": [
		85526,
		27231
	],
	"./NavigationCircleIcon": [
		97810,
		85421
	],
	"./NavigationCircleIcon.js": [
		97810,
		85421
	],
	"./NewLogoIcon": [
		14313,
		97827
	],
	"./NewLogoIcon.js": [
		14313,
		97827
	],
	"./NewSolidInvisibleEyeIcon": [
		92473,
		50260
	],
	"./NewSolidInvisibleEyeIcon.js": [
		92473,
		50260
	],
	"./NewVisibleEyeIcon": [
		78165,
		92070
	],
	"./NewVisibleEyeIcon.js": [
		78165,
		92070
	],
	"./NewsIcon": [
		21611,
		47440
	],
	"./NewsIcon.js": [
		21611,
		47440
	],
	"./NewsletterIcon": [
		24755,
		73058
	],
	"./NewsletterIcon.js": [
		24755,
		73058
	],
	"./NoCameraIcon": [
		42152,
		88284
	],
	"./NoCameraIcon.js": [
		42152,
		88284
	],
	"./NoDeviceIcon": [
		40909,
		64633
	],
	"./NoDeviceIcon.js": [
		40909,
		64633
	],
	"./NokiaIcon": [
		13490,
		90251
	],
	"./NokiaIcon.js": [
		13490,
		90251
	],
	"./NotificationIcon": [
		70023,
		67453
	],
	"./NotificationIcon.js": [
		70023,
		67453
	],
	"./OnePlusIcon": [
		33236,
		60847
	],
	"./OnePlusIcon.js": [
		33236,
		60847
	],
	"./OneappLogoIcon": [
		55380
	],
	"./OneappLogoIcon.js": [
		55380
	],
	"./OppoIcon": [
		84670,
		43442
	],
	"./OppoIcon.js": [
		84670,
		43442
	],
	"./OrderStatusIcon": [
		23850,
		1472
	],
	"./OrderStatusIcon.js": [
		23850,
		1472
	],
	"./PdfDownloadIcon": [
		69710,
		14038
	],
	"./PdfDownloadIcon.js": [
		69710,
		14038
	],
	"./PdfFileIcon": [
		42524,
		20644
	],
	"./PdfFileIcon.js": [
		42524,
		20644
	],
	"./PencilIcon": [
		98485,
		16858
	],
	"./PencilIcon.js": [
		98485,
		16858
	],
	"./PencilNewIcon": [
		25973,
		88143
	],
	"./PencilNewIcon.js": [
		25973,
		88143
	],
	"./PhilipsIcon": [
		71565,
		11101
	],
	"./PhilipsIcon.js": [
		71565,
		11101
	],
	"./PhoneNumberIcon": [
		78317,
		69131
	],
	"./PhoneNumberIcon.js": [
		78317,
		69131
	],
	"./PhotoCameraIcon": [
		2095,
		91929
	],
	"./PhotoCameraIcon.js": [
		2095,
		91929
	],
	"./PiggyBankIcon": [
		35614,
		26327
	],
	"./PiggyBankIcon.js": [
		35614,
		26327
	],
	"./PiggyIcon": [
		57244,
		30184
	],
	"./PiggyIcon.js": [
		57244,
		30184
	],
	"./PinIcon": [
		9071,
		55802
	],
	"./PinIcon.js": [
		9071,
		55802
	],
	"./PlansIcon": [
		62484,
		49196
	],
	"./PlansIcon.js": [
		62484,
		49196
	],
	"./PlansSolidIcon": [
		80279,
		74814
	],
	"./PlansSolidIcon.js": [
		80279,
		74814
	],
	"./PlusIcon": [
		97036,
		56768
	],
	"./PlusIcon.js": [
		97036,
		56768
	],
	"./PopUpWindowIcon": [
		59878,
		51805
	],
	"./PopUpWindowIcon.js": [
		59878,
		51805
	],
	"./PrepaidActivateIcon": [
		27798,
		45199
	],
	"./PrepaidActivateIcon.js": [
		27798,
		45199
	],
	"./ProcessingIcon": [
		11231,
		48985
	],
	"./ProcessingIcon.js": [
		11231,
		48985
	],
	"./PublishIcon": [
		84287,
		26187
	],
	"./PublishIcon.js": [
		84287,
		26187
	],
	"./RBMagentaWingsLogoIcon": [
		21670,
		41413
	],
	"./RBMagentaWingsLogoIcon.js": [
		21670,
		41413
	],
	"./RbmProfileIcon": [
		17600,
		10038
	],
	"./RbmProfileIcon.js": [
		17600,
		10038
	],
	"./RbmwCartIcon": [
		53734,
		16644
	],
	"./RbmwCartIcon.js": [
		53734,
		16644
	],
	"./RbmwLogoIcon": [
		52867,
		91026
	],
	"./RbmwLogoIcon.js": [
		52867,
		91026
	],
	"./RbmwNewLogoIcon": [
		68313,
		13824
	],
	"./RbmwNewLogoIcon.js": [
		68313,
		13824
	],
	"./RbmwProfileIcon": [
		53741,
		31870
	],
	"./RbmwProfileIcon.js": [
		53741,
		31870
	],
	"./RbmwSearchIcon": [
		39304,
		43846
	],
	"./RbmwSearchIcon.js": [
		39304,
		43846
	],
	"./RealmeIcon": [
		11366,
		50452
	],
	"./RealmeIcon.js": [
		11366,
		50452
	],
	"./RecipientIcon": [
		59375,
		24834
	],
	"./RecipientIcon.js": [
		59375,
		24834
	],
	"./RedBullMwLogoIcon": [
		66665,
		47632
	],
	"./RedBullMwLogoIcon.js": [
		66665,
		47632
	],
	"./RefreshIcon": [
		79231,
		65678
	],
	"./RefreshIcon.js": [
		79231,
		65678
	],
	"./RegionalIcon": [
		79353,
		85613
	],
	"./RegionalIcon.js": [
		79353,
		85613
	],
	"./ReloadIcon": [
		96981,
		79007
	],
	"./ReloadIcon.js": [
		96981,
		79007
	],
	"./RemoveIcon": [
		2796,
		82793
	],
	"./RemoveIcon.js": [
		2796,
		82793
	],
	"./ReplacementMobilephoneIcon": [
		44482,
		59995
	],
	"./ReplacementMobilephoneIcon.js": [
		44482,
		59995
	],
	"./ReplyForwardIcon": [
		7865,
		75221
	],
	"./ReplyForwardIcon.js": [
		7865,
		75221
	],
	"./RibbonIcon": [
		3852,
		79004
	],
	"./RibbonIcon.js": [
		3852,
		79004
	],
	"./RightDirectionIcon": [
		95991
	],
	"./RightDirectionIcon.js": [
		95991
	],
	"./RotateClockwiseIcon": [
		7071,
		59992
	],
	"./RotateClockwiseIcon.js": [
		7071,
		59992
	],
	"./RoundMinusIcon": [
		26212,
		1962
	],
	"./RoundMinusIcon.js": [
		26212,
		1962
	],
	"./RouterFilledIcon": [
		98985,
		57332
	],
	"./RouterFilledIcon.js": [
		98985,
		57332
	],
	"./RouterIcon": [
		44057,
		88547
	],
	"./RouterIcon.js": [
		44057,
		88547
	],
	"./RouterNotCompatibleIcon": [
		76792,
		11505
	],
	"./RouterNotCompatibleIcon.js": [
		76792,
		11505
	],
	"./SadFaceIcon": [
		4989,
		7719
	],
	"./SadFaceIcon.js": [
		4989,
		7719
	],
	"./SadFaceRoundIcon": [
		2747,
		30517
	],
	"./SadFaceRoundIcon.js": [
		2747,
		30517
	],
	"./SadFaceTwoIcon": [
		19157,
		15291
	],
	"./SadFaceTwoIcon.js": [
		19157,
		15291
	],
	"./SamsungIcon": [
		80636,
		7578
	],
	"./SamsungIcon.js": [
		80636,
		7578
	],
	"./SatTvIcon": [
		81374,
		30376
	],
	"./SatTvIcon.js": [
		81374,
		30376
	],
	"./ScheduleIcon": [
		21973,
		26590
	],
	"./ScheduleIcon.js": [
		21973,
		26590
	],
	"./SeamlessConnectivityIcon": [
		93248,
		49388
	],
	"./SeamlessConnectivityIcon.js": [
		93248,
		49388
	],
	"./SearchIcon": [
		85368,
		34162
	],
	"./SearchIcon.js": [
		85368,
		34162
	],
	"./SearchNewIcon": [
		40970,
		93537
	],
	"./SearchNewIcon.js": [
		40970,
		93537
	],
	"./SecurityIcon": [
		77570,
		70579
	],
	"./SecurityIcon.js": [
		77570,
		70579
	],
	"./SegwayIcon": [
		66124,
		96197
	],
	"./SegwayIcon.js": [
		66124,
		96197
	],
	"./SemiSolidChatIcon": [
		85819,
		89751
	],
	"./SemiSolidChatIcon.js": [
		85819,
		89751
	],
	"./ServiceSupportIcon": [
		89970,
		55353
	],
	"./ServiceSupportIcon.js": [
		89970,
		55353
	],
	"./ServicesIcon": [
		12564,
		3984
	],
	"./ServicesIcon.js": [
		12564,
		3984
	],
	"./SettingsIcon": [
		4309,
		29602
	],
	"./SettingsIcon.js": [
		4309,
		29602
	],
	"./ShopIcon": [
		97972,
		6804
	],
	"./ShopIcon.js": [
		97972,
		6804
	],
	"./ShopLocalizerIcon": [
		2427,
		48614
	],
	"./ShopLocalizerIcon.js": [
		2427,
		48614
	],
	"./ShoppingCartIcon": [
		65178,
		25816
	],
	"./ShoppingCartIcon.js": [
		65178,
		25816
	],
	"./ShoppingCartNewIcon": [
		90752,
		17047
	],
	"./ShoppingCartNewIcon.js": [
		90752,
		17047
	],
	"./ShoppingCartSolidIcon": [
		77601,
		91429
	],
	"./ShoppingCartSolidIcon.js": [
		77601,
		91429
	],
	"./ShowPasswordIcon": [
		91620,
		14227
	],
	"./ShowPasswordIcon.js": [
		91620,
		14227
	],
	"./SignalIcon": [
		85744,
		72417
	],
	"./SignalIcon.js": [
		85744,
		72417
	],
	"./SimCardIcon": [
		2929,
		95215
	],
	"./SimCardIcon.js": [
		2929,
		95215
	],
	"./SlugIcon": [
		27467,
		15502
	],
	"./SlugIcon.js": [
		27467,
		15502
	],
	"./SmartSpeakerIcon": [
		66434,
		38300
	],
	"./SmartSpeakerIcon.js": [
		66434,
		38300
	],
	"./SmarthomeIcon": [
		83362,
		44906
	],
	"./SmarthomeIcon.js": [
		83362,
		44906
	],
	"./SmartphoneDataTransferIcon": [
		53964,
		19288
	],
	"./SmartphoneDataTransferIcon.js": [
		53964,
		19288
	],
	"./SmartphoneIcon": [
		11635
	],
	"./SmartphoneIcon.js": [
		11635
	],
	"./SmileIcon": [
		59796,
		73461
	],
	"./SmileIcon.js": [
		59796,
		73461
	],
	"./SmsIcon": [
		32401,
		50663
	],
	"./SmsIcon.js": [
		32401,
		50663
	],
	"./SnapchatSolidIcon": [
		35005,
		54449
	],
	"./SnapchatSolidIcon.js": [
		35005,
		54449
	],
	"./SolidArrowLeftIcon": [
		47833,
		47843
	],
	"./SolidArrowLeftIcon.js": [
		47833,
		47843
	],
	"./SolidArrowRightIcon": [
		88498,
		35437
	],
	"./SolidArrowRightIcon.js": [
		88498,
		35437
	],
	"./SolidBgStockIcon": [
		22670,
		87079
	],
	"./SolidBgStockIcon.js": [
		22670,
		87079
	],
	"./SolidBusinessCardIcon": [
		41355,
		61461
	],
	"./SolidBusinessCardIcon.js": [
		41355,
		61461
	],
	"./SolidCalendarIcon": [
		19901,
		67907
	],
	"./SolidCalendarIcon.js": [
		19901,
		67907
	],
	"./SolidCallIcon": [
		36719,
		90865
	],
	"./SolidCallIcon.js": [
		36719,
		90865
	],
	"./SolidCancelIcon": [
		79665
	],
	"./SolidCancelIcon.js": [
		79665
	],
	"./SolidChatIcon": [
		6353,
		6080
	],
	"./SolidChatIcon.js": [
		6353,
		6080
	],
	"./SolidCircleErrorIcon": [
		44699,
		83282
	],
	"./SolidCircleErrorIcon.js": [
		44699,
		83282
	],
	"./SolidCircleInformationIcon": [
		13295,
		8900
	],
	"./SolidCircleInformationIcon.js": [
		13295,
		8900
	],
	"./SolidCollapseIcon": [
		79972,
		2294
	],
	"./SolidCollapseIcon.js": [
		79972,
		2294
	],
	"./SolidConfirmIcon": [
		71197,
		79496
	],
	"./SolidConfirmIcon.js": [
		71197,
		79496
	],
	"./SolidContinueIcon": [
		8010,
		47217
	],
	"./SolidContinueIcon.js": [
		8010,
		47217
	],
	"./SolidCreditCardIcon": [
		72936,
		40611
	],
	"./SolidCreditCardIcon.js": [
		72936,
		40611
	],
	"./SolidCrossIcon": [
		41233,
		66229
	],
	"./SolidCrossIcon.js": [
		41233,
		66229
	],
	"./SolidEditIcon": [
		30007,
		43431
	],
	"./SolidEditIcon.js": [
		30007,
		43431
	],
	"./SolidEmailIcon": [
		90357,
		25385
	],
	"./SolidEmailIcon.js": [
		90357,
		25385
	],
	"./SolidEquipmentIcon": [
		78469,
		37674
	],
	"./SolidEquipmentIcon.js": [
		78469,
		37674
	],
	"./SolidExpandIcon": [
		45815,
		12056
	],
	"./SolidExpandIcon.js": [
		45815,
		12056
	],
	"./SolidFilterIcon": [
		72869,
		8270
	],
	"./SolidFilterIcon.js": [
		72869,
		8270
	],
	"./SolidFilterNewIcon": [
		15429,
		31068
	],
	"./SolidFilterNewIcon.js": [
		15429,
		31068
	],
	"./SolidGiftIcon": [
		34653
	],
	"./SolidGiftIcon.js": [
		34653
	],
	"./SolidHandshakeIcon": [
		41756,
		6995
	],
	"./SolidHandshakeIcon.js": [
		41756,
		6995
	],
	"./SolidHelpIcon": [
		2616,
		65185
	],
	"./SolidHelpIcon.js": [
		2616,
		65185
	],
	"./SolidHomeIcon": [
		72116,
		9815
	],
	"./SolidHomeIcon.js": [
		72116,
		9815
	],
	"./SolidInformationIcon": [
		4499,
		84197
	],
	"./SolidInformationIcon.js": [
		4499,
		84197
	],
	"./SolidInvisibleIcon": [
		57582,
		68971
	],
	"./SolidInvisibleIcon.js": [
		57582,
		68971
	],
	"./SolidLoadingIcon": [
		36629,
		49036
	],
	"./SolidLoadingIcon.js": [
		36629,
		49036
	],
	"./SolidLockIcon": [
		192,
		74654
	],
	"./SolidLockIcon.js": [
		192,
		74654
	],
	"./SolidMediaFolderIcon": [
		96645,
		30024
	],
	"./SolidMediaFolderIcon.js": [
		96645,
		30024
	],
	"./SolidMinusIcon": [
		13293,
		55642
	],
	"./SolidMinusIcon.js": [
		13293,
		55642
	],
	"./SolidMnpsimCardIcon": [
		89829,
		59428
	],
	"./SolidMnpsimCardIcon.js": [
		89829,
		59428
	],
	"./SolidNewGiftIcon": [
		1321,
		50941
	],
	"./SolidNewGiftIcon.js": [
		1321,
		50941
	],
	"./SolidNewsletterIcon": [
		79992,
		44335
	],
	"./SolidNewsletterIcon.js": [
		79992,
		44335
	],
	"./SolidPhotoCameraIcon": [
		85754,
		48121
	],
	"./SolidPhotoCameraIcon.js": [
		85754,
		48121
	],
	"./SolidPlusIcon": [
		44720,
		73739
	],
	"./SolidPlusIcon.js": [
		44720,
		73739
	],
	"./SolidPlusTwoIcon": [
		32975,
		88965
	],
	"./SolidPlusTwoIcon.js": [
		32975,
		88965
	],
	"./SolidRegionalIcon": [
		35670,
		97526
	],
	"./SolidRegionalIcon.js": [
		35670,
		97526
	],
	"./SolidScheduleIcon": [
		83906,
		4132
	],
	"./SolidScheduleIcon.js": [
		83906,
		4132
	],
	"./SolidSearchIcon": [
		46623,
		26930
	],
	"./SolidSearchIcon.js": [
		46623,
		26930
	],
	"./SolidShopLocalizerIcon": [
		86346,
		1312
	],
	"./SolidShopLocalizerIcon.js": [
		86346,
		1312
	],
	"./SolidShoppingCartIcon": [
		44885,
		19358
	],
	"./SolidShoppingCartIcon.js": [
		44885,
		19358
	],
	"./SolidSimCardIcon": [
		93144,
		3631
	],
	"./SolidSimCardIcon.js": [
		93144,
		3631
	],
	"./SolidSimIcon": [
		1194,
		10237
	],
	"./SolidSimIcon.js": [
		1194,
		10237
	],
	"./SolidSmartphoneIcon": [
		25152,
		33035
	],
	"./SolidSmartphoneIcon.js": [
		25152,
		33035
	],
	"./SolidSmsIcon": [
		53864,
		7417
	],
	"./SolidSmsIcon.js": [
		53864,
		7417
	],
	"./SolidSuccessIcon": [
		69022,
		25463
	],
	"./SolidSuccessIcon.js": [
		69022,
		25463
	],
	"./SolidTransporterIcon": [
		78707,
		82440
	],
	"./SolidTransporterIcon.js": [
		78707,
		82440
	],
	"./SolidTransporterRightsideIcon": [
		82788
	],
	"./SolidTransporterRightsideIcon.js": [
		82788
	],
	"./SolidTrashIcon": [
		72291,
		1452
	],
	"./SolidTrashIcon.js": [
		72291,
		1452
	],
	"./SolidUserAccountIcon": [
		91259,
		78654
	],
	"./SolidUserAccountIcon.js": [
		91259,
		78654
	],
	"./SolidVisibleIcon": [
		88983,
		44256
	],
	"./SolidVisibleIcon.js": [
		88983,
		44256
	],
	"./SolidWarningIcon": [
		89293,
		34584
	],
	"./SolidWarningIcon.js": [
		89293,
		34584
	],
	"./SolidZoomInIcon": [
		43083,
		11786
	],
	"./SolidZoomInIcon.js": [
		43083,
		11786
	],
	"./SolidZoomOutIcon": [
		80940,
		5180
	],
	"./SolidZoomOutIcon.js": [
		80940,
		5180
	],
	"./SonyIcon": [
		34451,
		30798
	],
	"./SonyIcon.js": [
		34451,
		30798
	],
	"./SortIcon": [
		99776,
		12752
	],
	"./SortIcon.js": [
		99776,
		12752
	],
	"./SortNewIcon": [
		76466,
		44127
	],
	"./SortNewIcon.js": [
		76466,
		44127
	],
	"./SortSolidIcon": [
		2451,
		67085
	],
	"./SortSolidIcon.js": [
		2451,
		67085
	],
	"./SpecialOfferIcon": [
		42703,
		41467
	],
	"./SpecialOfferIcon.js": [
		42703,
		41467
	],
	"./StarIcon": [
		54856,
		47913
	],
	"./StarIcon.js": [
		54856,
		47913
	],
	"./StarSolidIcon": [
		17275,
		82311
	],
	"./StarSolidIcon.js": [
		17275,
		82311
	],
	"./StartIcon": [
		43592,
		11074
	],
	"./StartIcon.js": [
		43592,
		11074
	],
	"./StbIcon": [
		22339,
		85456
	],
	"./StbIcon.js": [
		22339,
		85456
	],
	"./StreamOnIcon": [
		98217,
		30086
	],
	"./StreamOnIcon.js": [
		98217,
		30086
	],
	"./StrickedCricleOnlyBorderIcon": [
		85679
	],
	"./StrickedCricleOnlyBorderIcon.js": [
		85679
	],
	"./StrikedCircleIcon": [
		23734
	],
	"./StrikedCircleIcon.js": [
		23734
	],
	"./SubcriptionIcon": [
		86080
	],
	"./SubcriptionIcon.js": [
		86080
	],
	"./SuccessIcon": [
		40211,
		46235
	],
	"./SuccessIcon.js": [
		40211,
		46235
	],
	"./SummaryCollapseIcon": [
		63399,
		23437
	],
	"./SummaryCollapseIcon.js": [
		63399,
		23437
	],
	"./SummaryExpandIcon": [
		69448,
		65247
	],
	"./SummaryExpandIcon.js": [
		69448,
		65247
	],
	"./SupportIcon": [
		55543,
		42449
	],
	"./SupportIcon.js": [
		55543,
		42449
	],
	"./SustainableIcon": [
		90317,
		54660
	],
	"./SustainableIcon.js": [
		90317,
		54660
	],
	"./SwitchUsersIcon": [
		33768,
		48054
	],
	"./SwitchUsersIcon.js": [
		33768,
		48054
	],
	"./TariffsIcon": [
		39571,
		51840
	],
	"./TariffsIcon.js": [
		39571,
		51840
	],
	"./TclIcon": [
		45243,
		29042
	],
	"./TclIcon.js": [
		45243,
		29042
	],
	"./TechbriteIcon": [
		56852,
		44268
	],
	"./TechbriteIcon.js": [
		56852,
		44268
	],
	"./TelekomShopAIcon": [
		22304,
		64203
	],
	"./TelekomShopAIcon.js": [
		22304,
		64203
	],
	"./TelekomShopBIcon": [
		26077,
		87001
	],
	"./TelekomShopBIcon.js": [
		26077,
		87001
	],
	"./TelekomShopCIcon": [
		93570,
		83215
	],
	"./TelekomShopCIcon.js": [
		93570,
		83215
	],
	"./ThreeSixtyIcon": [
		57991,
		89821
	],
	"./ThreeSixtyIcon.js": [
		57991,
		89821
	],
	"./TickIcon": [
		5589,
		2227
	],
	"./TickIcon.js": [
		5589,
		2227
	],
	"./TiktokIcon": [
		8118,
		37678
	],
	"./TiktokIcon.js": [
		8118,
		37678
	],
	"./TilesAddIcon": [
		41448,
		60476
	],
	"./TilesAddIcon.js": [
		41448,
		60476
	],
	"./TodoListIcon": [
		36228,
		67082
	],
	"./TodoListIcon.js": [
		36228,
		67082
	],
	"./TradeInIcon": [
		53965,
		41464
	],
	"./TradeInIcon.js": [
		53965,
		41464
	],
	"./TradeInPurpleIcon": [
		51859,
		64262
	],
	"./TradeInPurpleIcon.js": [
		51859,
		64262
	],
	"./TransportIcon": [
		33701,
		95637
	],
	"./TransportIcon.js": [
		33701,
		95637
	],
	"./TransporterIcon": [
		37154,
		72839
	],
	"./TransporterIcon.js": [
		37154,
		72839
	],
	"./TransporterRightIcon": [
		14444,
		76625
	],
	"./TransporterRightIcon.js": [
		14444,
		76625
	],
	"./TransporterRightSolidIcon": [
		55471,
		70019
	],
	"./TransporterRightSolidIcon.js": [
		55471,
		70019
	],
	"./TrashIcon": [
		28310,
		57613
	],
	"./TrashIcon.js": [
		28310,
		57613
	],
	"./TriangleDownIcon": [
		57376,
		26160
	],
	"./TriangleDownIcon.js": [
		57376,
		26160
	],
	"./TriangleUpIcon": [
		67301,
		51778
	],
	"./TriangleUpIcon.js": [
		67301,
		51778
	],
	"./TvAddonIcon": [
		93344,
		28980
	],
	"./TvAddonIcon.js": [
		93344,
		28980
	],
	"./TvAndMobileIcon": [
		88141,
		70790
	],
	"./TvAndMobileIcon.js": [
		88141,
		70790
	],
	"./TvIcon": [
		47250
	],
	"./TvIcon.js": [
		47250
	],
	"./TwitterIcon": [
		6595,
		39223
	],
	"./TwitterIcon.js": [
		6595,
		39223
	],
	"./UnlockIcon": [
		66084,
		13605
	],
	"./UnlockIcon.js": [
		66084,
		13605
	],
	"./UploadIcon": [
		2341,
		36403
	],
	"./UploadIcon.js": [
		2341,
		36403
	],
	"./UsageIcon": [
		14139,
		94593
	],
	"./UsageIcon.js": [
		14139,
		94593
	],
	"./UserAccountIcon": [
		62946,
		17391
	],
	"./UserAccountIcon.js": [
		62946,
		17391
	],
	"./UserFileVideosIcon": [
		79109,
		22713
	],
	"./UserFileVideosIcon.js": [
		79109,
		22713
	],
	"./UserIcon": [
		23619,
		99915
	],
	"./UserIcon.js": [
		23619,
		99915
	],
	"./UserSolidIcon": [
		2970,
		25533
	],
	"./UserSolidIcon.js": [
		2970,
		25533
	],
	"./VideoOptionIcon": [
		26230,
		18927
	],
	"./VideoOptionIcon.js": [
		26230,
		18927
	],
	"./VideosIcon": [
		40196,
		96129
	],
	"./VideosIcon.js": [
		40196,
		96129
	],
	"./VisaIcon": [
		19325,
		64754
	],
	"./VisaIcon.js": [
		19325,
		64754
	],
	"./VisaNewIcon": [
		381,
		87552
	],
	"./VisaNewIcon.js": [
		381,
		87552
	],
	"./VisibleIcon": [
		72010,
		83766
	],
	"./VisibleIcon.js": [
		72010,
		83766
	],
	"./VoiceMessageIcon": [
		99465,
		90372
	],
	"./VoiceMessageIcon.js": [
		99465,
		90372
	],
	"./VoucherIcon": [
		5538,
		86586
	],
	"./VoucherIcon.js": [
		5538,
		86586
	],
	"./WalletIcon": [
		12113,
		25807
	],
	"./WalletIcon.js": [
		12113,
		25807
	],
	"./WarningIcon": [
		84644,
		32413
	],
	"./WarningIcon.js": [
		84644,
		32413
	],
	"./WhatsappSolidIcon": [
		7285,
		55211
	],
	"./WhatsappSolidIcon.js": [
		7285,
		55211
	],
	"./WifiIcon": [
		54125,
		29593
	],
	"./WifiIcon.js": [
		54125,
		29593
	],
	"./WinkIcon": [
		36171,
		47639
	],
	"./WinkIcon.js": [
		36171,
		47639
	],
	"./XiaomiFullIcon": [
		3544,
		4616
	],
	"./XiaomiFullIcon.js": [
		3544,
		4616
	],
	"./XiaomiIcon": [
		25245,
		81818
	],
	"./XiaomiIcon.js": [
		25245,
		81818
	],
	"./XiaomiOldIcon": [
		78174,
		23628
	],
	"./XiaomiOldIcon.js": [
		78174,
		23628
	],
	"./YoutubeIcon": [
		58661,
		830
	],
	"./YoutubeIcon.js": [
		58661,
		830
	],
	"./ZoomInIcon": [
		75400,
		82784
	],
	"./ZoomInIcon.js": [
		75400,
		82784
	],
	"./ZoomOutIcon": [
		82537,
		65669
	],
	"./ZoomOutIcon.js": [
		82537,
		65669
	],
	"./ZteIcon": [
		10025,
		91287
	],
	"./ZteIcon.js": [
		10025,
		91287
	],
	"./index": [
		373,
		60847,
		24705
	],
	"./index.js": [
		373,
		60847,
		24705
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 65434;
module.exports = webpackAsyncContext;